import Vue from 'vue'
import VueRouter, {Route, RouteConfig} from 'vue-router'
import goTo from './goto-shim'
import {authModule} from "@/store";

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    {
        path: '/',
        name: 'login',
        component: () => import('@/views/LoginView.vue'),
        meta: {
            public: true
        }
    },
    {
        path: '/home',
        name: 'home',
        component: () => import('@/views/HomeView.vue')
    },
    {
        path: '/externalredirect',
        name: 'externalredirect',
        component: () => import('@/views/ExternalRedirectView.vue'),
        props: route => ({
            refreshToken: route.query.refreshToken,
            url: route.query.url
        }),
        meta: {
            public: true,
        }
    },
    {
        path: '/impressum',
        name: 'impressum',
        component: () => import('@/views/ImpressumView.vue'),
        meta: {
            public: true
        }
    },
    {
        path: '/admin/usersadmin',
        name: 'usersadmin',
        component: () => import('@/views/admin/UsersAdmin.vue')
    },
    {
        path: '/admin/usersadmin',
        name: 'useraudittrail',
        component: () => import('@/views/eCRF/audittrail/UserAuditTrailView.vue'),
        props: true
    },
    {
        path: '/patients',
        name: 'patients',
        component: () => import('@/views/Patients.vue')
    },
    {
        path: '/dataVisualization',
        name: 'dataVisualization',
        component: () => import('@/views/DataVisualization.vue')
    },
    {
        path: '/patient/edit/:patientId',
        name: 'patientedit',
        component: () => import('@/views/eCRF/PatientEditView.vue'),
        props: true,
    },
    {
        path: '/patient/new',
        name: 'patientnew',
        component: () => import('@/views/eCRF/PatientNewView.vue')
    },
    {
        path: '/patient/:patientId/visit/:visitDefinitionId/new',
        name: 'visitnew',
        component: () => import('@/views/eCRF/VisitNewView.vue'),
        props: true,
    },
    {
        path: '/patient/:patientId/visit/:visitId/edit',
        name: 'visitedit',
        component: () => import('@/views/eCRF/VisitEditView.vue'),
        props: true,
    },
    {
        path: '/patient/:patientId',
        name: 'patient',
        props: true,
        component: () => import('@/views/eCRF/PatientView.vue')
    },
    {
        path: '/patient/audittrail/:patientId',
        name: 'patientaudittrail',
        props: true,
        component: () => import('@/views/eCRF/audittrail/StudyPatientAuditTrailView.vue')
    },
    {
        path: '/institutes',
        name: 'institutes',
        component: () => import('@/views/eCRF/StudyInstitutes.vue')
    },
    {
        path: '/admin/ntdInstitutes',
        name: 'ntdInstitutes',
        component: () => import('@/views/admin/NtdInstitutes.vue'),
    }, {
        path: '/admin/ntdUsers',
        name: 'ntdUsers',
        component: () => import('@/views/admin/NtdUsers.vue'),
    },
    {
        path: '/calendar',
        name: 'calendar',
        component: () => import('@/views/CalendarView.vue')
    },
    {
        path: '/documents',
        name: 'documents',
        component: () => import('@/views/DocumentsView.vue')
    },
    {
        path: '/patient/:patientId/visit/:visitId/instrument/:instrumentId/edit',
        name: 'visitinstrumentedit',
        props: true,
        component: () => import('@/views/eCRF/InstrumentView.vue'),
        meta: {
            instrumentView: true
        }
    },
    {
        path: '/patient/audittrail/:patientId/visit/:visitId/instrument/:instrumentId/edit',
        name: 'visitinstrumentaudittrail',
        props: true,
        component: () => import('@/views/eCRF/audittrail/InstrumentAuditTrailView.vue')
    },
    {
        path: '/patient/:patientId/visit/:visitId',
        name: 'visitinstrument',
        props: true,
        component: () => import('@/views/eCRF/InstrumentView.vue'),
        meta: {
            instrumentView: true
        }
    },
    {
        path: '/patient/audittrail/:patientId/visit/:visitId',
        name: 'visitaudittrail',
        props: true,
        component: () => import('@/views/eCRF/audittrail/VisitAuditTrailView.vue')
    },
    {
        path: '/patient/:patientId/visit/:visitId/instrument/:instrumentDefinitionId/new',
        name: 'visitinstrumentnew',
        props: true,
        component: () => import('@/views/eCRF/InstrumentView.vue'),
        meta: {
            instrumentView: true
        }
    },
    {
        path: '/patient/:patientId/instrument/:instrumentId/edit',
        name: 'standaloneinstrumentedit',
        props: true,
        component: () => import('@/views/eCRF/InstrumentView.vue'),
        meta: {
            instrumentView: true
        }
    },
    {
        path: '/patient/:patientId/instrument/:instrumentDefinitionId/new',
        name: 'standaloneinstrumentnew',
        props: true,
        component: () => import('@/views/eCRF/InstrumentView.vue'),
        meta: {
            instrumentView: true
        }
    },
    {
        path: '/patient/audittrail/:patientId/instrument/:instrumentId/edit',
        name: 'standaloneinstrumentaudittrail',
        props: true,
        component: () => import('@/views/eCRF/audittrail/InstrumentAuditTrailView.vue')
    },
    {
        path: '/institutesoverview',
        name: 'institutesoverview',
        component: () => import('@/views/eCRF/StudyInstitutesOverview.vue')
    },
    {
        path: '/studyInstitute/audittrail/:studyInstituteId',
        name: 'studyinstituteaudittrail',
        props: true,
        component: () => import('@/views/eCRF/audittrail/StudyInstituteAuditTrailView.vue')
    },
    {
        path: '/passwordrecovery',
        name: 'passwordrecovery',
        component: () => import('@/views/PasswordRecovery/UserPasswordRecoveryView.vue'),
        meta: {
            public: true
        }
    },
    {
        path: '/passwordreset/:userId',
        name: 'passwordreset',
        component: () => import('@/views/PasswordRecovery/UserPasswordResetView.vue'),
        props: route => ({
            userId: route.params.userId,
            challenge: route.query.challenge
        }),
        meta: {
            public: true
        }
    },
    {
        path: '/safety/freetextreport',
        name: 'safety-freetextreport',
        component: () => import('@/views/eCRF/safety/SafetyFreeTextReportView.vue'),
    },
    {
        path: '/safety/report',
        name: 'safety-report',
        component: () => import('@/views/eCRF/safety/SafetyScreeningReportView.vue'),
    },
    {
        path: '/safety/event-report-overview',
        name: 'event-report-overview',
        component: () => import('@/views/eCRF/safety/EventReportView.vue'),
    },
    {
        path: '/documentation',
        name: 'documentation',
        component: () => import('@/views/admin/Documentation.vue')
    },
    {
        path: '/exports',
        name: 'exports',
        component: () => import('@/views/admin/exports/Exports.vue'),
    },
    {
        path: '/query-overview',
        name: 'query-overview',
        component: () => import('@/views/eCRF/safety/QueryOverview.vue'),
    },
    {
        path: '/query/audittrail/:queryId',
        name: 'queryaudittrail',
        props: true,
        component: () => import('@/views/eCRF/audittrail/QueryAuditTrailView.vue')
    },
    {
        path: '/admin/study-definition',
        name: 'study-definition',
        component: () => import('@/views/admin/StudyDefinitionAdmin.vue')
    },
    {
        path: '/admin/data-migrations',
        name: 'data-migrations',
        component: () => import('@/views/admin/DataMigrationView.vue')
    },
]

const scrollBehavior = function (to: Route, from: Route, savedPosition: any) {
    if (to.hash) {
        return goTo(to.hash)
    } else if (savedPosition) {
        return goTo(savedPosition.y)
    }
    return goTo(0)
};

const router = new VueRouter({
    base: process.env.BASE_URL,
    scrollBehavior,
    routes
})


router.beforeEach(async (to, from, next) => {
    // skip public pages
    if (to.meta?.public === true) {
        return next();
    }

    // redirect to login page if not logged in and trying to access a restricted page
    if (!authModule.loggedIn) {
        return next("/")
    }

    return next();
})

export default router
